import React from "react";
import FAQData from "./FAQData";
import classes from "../../components/Blog.module.css";
import { Link } from "react-router-dom";

export default function FAQTreeView() {
  const RecentFAQ = [...FAQData].sort((a, b) => b.id - a.id).slice(1, 4);
  return (
    <>
      <div className="mb-1 p-3 bg-white">
        <h5 className={classes.h4}>Recent FAQs</h5>
        <div className={classes.List}>
          <ul className=" list-unstyled m-2 gap-2">
            {RecentFAQ.map((item) => (
              <li>
                <Link
                  className="nav-link"
                  to={`/FAQArticle/${item.category
                    .replace(/\s+/g, "-")
                    .toLowerCase()}`}
                >
                  {item.question}
                </Link>{" "}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mb-1 p-3 bg-white">
        <h5 className={classes.h4}>FAQs Published</h5>
        <div className={classes.List}>
          <ul className=" list-unstyled m-2 gap-2">
            {FAQData.map((item) => (
              <li>
                <Link
                  className="nav-link"
                  to={`/FAQArticle/${item.category
                    .replace(/\s+/g, "-")
                    .toLowerCase()}`}
                >
                  {item.question
                    .replace(
                      /[\p{Emoji_Presentation}\p{Extended_Pictographic}]+$/gu,
                      "",
                    )
                    .trim()}
                </Link>{" "}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
